import { render } from "./LoginBanner.vue?vue&type=template&id=00571c90"
import script from "./LoginBanner.vue?vue&type=script&lang=js"
export * from "./LoginBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__